import { useQuery } from "@apollo/client"
import View from "@pathwright/ui/src/components/ui/View"
import { COHORTS_INCLUDED_PRODUCTS_QUERY } from "@pathwright/features/src/modules/cohort/graphql"
import { flattenEdges } from "@pathwright/features/src/modules/utils/apollo"
import get from "lodash/get"
import ResourceLicenseOfferingForm from "./ResourceLicenseOfferingForm"
import "./ResourceOffering.css"
import ResourceOfferingFormContainer from "./ResourceOfferingFormContainer"
import ResourceOfferingInfo from "./ResourceOfferingInfo"

const ResourceOffering = function ({ resource, offering }) {
  const showForm =
    !!offering.permissions &&
    ((offering.permissions.can_access && !offering.permissions.can_edit) ||
      !offering.permissions.can_facilitate)

  const query = useQuery(COHORTS_INCLUDED_PRODUCTS_QUERY, {
    variables: {
      resourceId: resource.id,
      visibilityFilter: { gt: "private" }
    }
  })

  const cohorts = flattenEdges(get(query.data, "groups", []))
  const cohort = cohorts.find((cohort) => cohort.id === offering.id)
  // merge include_with_products field from graphql query
  const massagedOffering = {
    ...offering,
    // store in separate key from include_with_products to avoid corrupting expected data shape!
    include_with_products_data: get(cohort, "include_with_products", [])
  }

  return (
    <View.Primary className="ResourceOffering" rounded shadow>
      <View borderBottom={showForm}>
        <ResourceOfferingInfo resource={resource} offering={massagedOffering} />
      </View>
      {showForm ? (
        massagedOffering.is_license_offering ? (
          <ResourceLicenseOfferingForm offering={massagedOffering} />
        ) : (
          <ResourceOfferingFormContainer offering={massagedOffering} />
        )
      ) : null}
    </View.Primary>
  )
}

ResourceOffering.displayName = "ResourceOffering"
export default ResourceOffering
